/**
* GeolocationServices
*/
import { DataLoader } from '../loaders';

const GeolocationError = {
    PERMISSION_DENIED: 1,
    POSITION_UNAVAILABLE: 2,
    TIMEOUT: 3
};

class Geolocation {
    constructor() {
        this.latestDeviceLatitude = 0;
        this.latestDeviceLongitude = 0;
    }

    get(timeout, callback) {
        var that = this;

        if(!navigator.geolocation) {
            that.latestDeviceLatitude = 0;
            that.latestDeviceLongitude = 0;

            if(callback) {
                callback({ available: false, denied: false, });
            }
        }
        else {
            this.getCurrentLocation(
                timeout,

                function(latitude, longitude, originalData) {
                    that.latestDeviceLatitude = latitude;
                    that.latestDeviceLongitude = longitude;

                    if(callback) {
                        callback({ available: true, denied: false, latitude: latitude, longitude: longitude, originalData: originalData });
                    }
                },

                function(error) {
                    that.latestDeviceLatitude = 0;
                    that.latestDeviceLongitude = 0;

                    if(error.code == GeolocationError.PERMISSION_DENIED) {
                        if(callback) {
                            callback({ available: false, denied: true });
                        }
                    }
                    else {
                        if(callback) {
                            callback({ available: false, denied: false });
                        }
                    }
                }
            );
        }
    }

    getCurrentLocation(timeout, successCallback, errorCallback) {
        var that = this;
        var options = { maximumAge: 10000 };
        if(timeout) options.timeout = 8000;

        navigator.geolocation.getCurrentPosition(
            function(data) {
                if(successCallback) {
                    successCallback(data.coords.latitude, data.coords.longitude, data.coords);
                }
            },

            function(error) {
                if(errorCallback) {
                    errorCallback(error);
                }
            },

            options
        );
    }

    getCityByCoordinates(latitude, longitude, callback) {
        new DataLoader({
            url: '/common/location-get-by-coordinates/' + latitude + '/' + longitude + '/',

            success: function(data) {
                if(callback) {
                    if(data.status) {
                        callback({
                            status: true,
                            id: data.location.id,
                            city: data.location.city,
                            country: data.location.country,
                            country_code: data.location.country_code
                        });
                    }
                    else {
                        callback({ status: false });
                    }
                }
            },

            error: function() {
                if(callback) {
                    callback({ status: false });
                }
            }
        });
    }
}

export { Geolocation }
